import React, { useState, useEffect, useCallback } from 'react';
import { systemCredentialsService } from '../services/api';
import { fmtDate, getDaysUntil } from '../utils/formatters';
import CascaDeModal from './shared/CascaDeModal';
import { useConfirmarPerigo } from './shared/ConfirmDialog';
import { campo, useEstadoDaCarga, EstadoDaLista, A_PROPRIA_LISTA_DIZ_O_VAZIO, mensagemDoErroDeCarga } from '../design';
import { useAviso } from './shared/Aviso';
import { TONE_TEXT, TONE_BADGE, TONE_BORDER } from '../utils/statusColors';
import { NAO_TESTADAS, FRASE_DO_NAO_TESTADO } from '../utils/configuracoes';

const Icon = ({ name, className = 'w-5 h-5' }: { name: string; className?: string }) => {
  const icons: any = {
    key: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z' /></svg>,
    check: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M5 13l4 4L19 7' /></svg>,
    x: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M6 18L18 6M6 6l12 12' /></svg>,
    clock: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' /></svg>,
    alert: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z' /></svg>,
    refresh: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15' /></svg>,
    plus: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M12 4v16m8-8H4' /></svg>,
    edit: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z' /></svg>,
    trash: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16' /></svg>,
    cloud: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z' /></svg>,
    github: <svg className={className} fill='currentColor' viewBox='0 0 24 24'><path d='M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z'/></svg>,
    mail: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' /></svg>,
    signature: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z' /></svg>,
    fiscal: <svg className={className} fill='none' stroke='currentColor' viewBox='0 0 24 24'><path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' /></svg>,
  };
  return icons[name] || null;
};

interface Credential {
  id: number;
  name: string;
  type: string;
  status: string;
  description: string;
  expiresAt: string | null;
  lastCheckedAt: string | null;
  lastUsedAt: string | null;
  notes: string;
  metadata: Record<string, any>;
  isActive: boolean;
  alertDaysBefore: number;
  createdAt: string;
  updatedAt: string;
}

interface ConnectionStatus {
  success: boolean;
  message: string;
  [key: string]: any;
}

// Cor (11/10/2026, PR-2 da medição): o estado da credencial sai do mapa de tons.
const statusColors: Record<string, { bg: string; text: string; border: string }> = {
  'Ativo': { bg: TONE_BADGE.open, text: '', border: TONE_BORDER.open },
  'Expirando': { bg: TONE_BADGE.warning, text: '', border: TONE_BORDER.warning },
  'Expirado': { bg: TONE_BADGE.danger, text: '', border: TONE_BORDER.danger },
  'Erro': { bg: TONE_BADGE.danger, text: '', border: TONE_BORDER.danger },
  'Desconhecido': { bg: TONE_BADGE.neutral, text: '', border: TONE_BORDER.neutral },
};

const typeIcons: Record<string, string> = {
  'AWS': 'cloud',
  'GitHub': 'github',
  'ClickSign': 'signature',
  'NuvemFiscal': 'fiscal',
  'Other': 'key',
};

const connectionLabels: Record<string, string> = {
  aws: 'AWS',
  clicksign: 'ClickSign',
  nuvemFiscal: 'Nuvem Fiscal',
  // D2: o backend responde `focusNfe` desde a troca de emissor; o card saía com o rótulo cru e sem detalhes.
  focusNfe: 'Focus NFe',
};

export default function CredentialsSettings() {
  const confirmarPerigo = useConfirmarPerigo();
  const [credentials, setCredentials] = useState<Credential[]>([]);
  const [connections, setConnections] = useState<Record<string, ConnectionStatus>>({});
  // D2: o teste que falhava só logava e deixava os cards verdes do teste anterior, sem dizer de quando eram.
  const [connectionsErro, setConnectionsErro] = useState<string | null>(null);
  const avisar = useAviso();
  // D5: a lista que não carregava dizia "Nenhuma credencial cadastrada" e oferecia "Criar Padrões".
  const carga = useEstadoDaCarga();
  const rodarCarga = carga.rodar;
  const [loading, setLoading] = useState(true);
  const [checkingConnections, setCheckingConnections] = useState(false);
  const [modal, setModal] = useState<'create' | 'edit' | null>(null);
  const [selectedCredential, setSelectedCredential] = useState<Credential | null>(null);
  const [saving, setSaving] = useState(false);

  const emptyForm = {
    name: '',
    type: 'Other',
    description: '',
    expiresAt: '',
    notes: '',
    alertDaysBefore: 14,
  };
  const [form, setForm] = useState<any>(emptyForm);

  const loadData = useCallback(async () => {
    setLoading(true);
    await rodarCarga(async () => {
      const credData = await systemCredentialsService.getAll();
      setCredentials(Array.isArray(credData) ? credData : []);
    });
    setLoading(false);
  }, [rodarCarga]);

  const checkConnections = async () => {
    setCheckingConnections(true);
    try {
      const result = await systemCredentialsService.checkConnections();
      setConnections(result);
      setConnectionsErro(null);
    } catch (e) {
      setConnections({});
      setConnectionsErro(mensagemDoErroDeCarga(e));
    }
    setCheckingConnections(false);
  };

  const seedDefaults = async () => {
    try {
      await systemCredentialsService.seed();
      loadData();
    } catch (e: any) {
      avisar(`Não criei as credenciais padrão: ${e?.response?.data?.message || mensagemDoErroDeCarga(e)}`, 'error');
    }
  };

  useEffect(() => {
    loadData();
    checkConnections();
  }, [loadData]);


  const handleCreate = () => {
    setForm(emptyForm);
    setSelectedCredential(null);
    setModal('create');
  };

  const handleEdit = (credential: Credential) => {
    setForm({
      name: credential.name,
      type: credential.type,
      description: credential.description || '',
      expiresAt: credential.expiresAt ? credential.expiresAt.split('T')[0] : '',
      notes: credential.notes || '',
      alertDaysBefore: credential.alertDaysBefore || 14,
    });
    setSelectedCredential(credential);
    setModal('edit');
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      if (selectedCredential) {
        await systemCredentialsService.update(selectedCredential.id, form);
      } else {
        await systemCredentialsService.create(form);
      }
      setModal(null);
      loadData();
    } catch (e: any) {
      avisar('Não salvei: ' + (e.response?.data?.message || mensagemDoErroDeCarga(e)), 'error');
    }
    setSaving(false);
  };

  const handleDelete = async (credential: Credential) => {
    if (!await confirmarPerigo(`Deseja excluir a credencial "${credential.name}"?\n\nNenhuma integração lê este cadastro, então nada deixa de funcionar. O que se perde é o aviso de vencimento desta credencial.`)) return;
    try {
      await systemCredentialsService.delete(credential.id);
      loadData();
    } catch (e: any) {
      // 404 = já não existe: o estado desejado é o estado atual. Ver ProposalsTab.
      if (e?.response?.status === 404) { loadData(); return; }
      avisar('Não excluí: ' + (e.response?.data?.message || mensagemDoErroDeCarga(e)), 'error');
    }
  };

  if (loading && carga.atualizadoEm === null && carga.estado !== 'erro') {
    return (
      <div className='flex items-center justify-center h-32'>
        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500'></div>
      </div>
    );
  }

  return (
    <div className='bg-slate-900 rounded-xl border border-slate-800 overflow-hidden'>
      <div className='p-4 border-b border-slate-800 flex items-center justify-between'>
        <div className='flex items-center gap-3'>
          <div className='p-2 bg-slate-700/50 rounded-lg'>
            <Icon name='key' className='w-5 h-5 text-slate-300' />
          </div>
          <div>
            <h3 className='text-white font-semibold'>Credenciais e Integrações</h3>
            <p className='text-slate-400 text-sm'>Gerenciar chaves de API, tokens e conexões externas</p>
          </div>
        </div>
        <div className='flex gap-2'>
          <button
            onClick={checkConnections}
            disabled={checkingConnections}
            className='flex items-center gap-2 px-3 py-2 text-sm text-slate-300 bg-slate-800 rounded-lg hover:bg-slate-700 disabled:opacity-50'
          >
            <Icon name='refresh' className={`w-4 h-4 ${checkingConnections ? 'animate-spin' : ''}`} />
            Testar Conexões
          </button>
          {carga.estado === 'pronto' && credentials.length === 0 && (
            <button
              onClick={seedDefaults}
              className='flex items-center gap-2 px-3 py-2 text-sm text-slate-200 bg-slate-700 rounded-lg hover:bg-slate-600'
            >
              <Icon name='plus' className='w-4 h-4' />
              Criar Padrões
            </button>
          )}
          {carga.estado === 'pronto' && (
          <button
            onClick={handleCreate}
            className='flex items-center gap-2 px-3 py-2 text-sm text-white bg-primary rounded-lg hover:bg-primary-strong'
          >
            <Icon name='plus' className='w-4 h-4' />
            Nova Credencial
          </button>
          )}
        </div>
      </div>

      <div className='p-6'>
        {connectionsErro && (
          <p role='alert' className={`mb-6 text-sm ${TONE_TEXT.danger}`}>
            Não consegui testar as conexões ({connectionsErro}). Nenhum status abaixo é deste teste.
          </p>
        )}
        {/* Status das Conexões */}
        {Object.keys(connections).length > 0 && (
          <div className='mb-6'>
            <h4 className='text-sm font-semibold text-slate-300 mb-3'>Status das Conexões</h4>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3'>
              {Object.entries(connections).filter(([key]) => key !== 'smtp').map(([key, status]) => {
                // D2: ClickSign (e SMTP) só conferem se a variável existe; "Configurado" em verde dizia que funcionava.
                const naoTestada = status.success && NAO_TESTADAS.includes(key);
                return (
                <div key={key} className={`p-3 rounded-lg border ${naoTestada ? 'bg-slate-800 border-slate-700' : status.success ? 'bg-green-500/10 border-green-500/30' : 'bg-red-500/10 border-red-500/30'}`}>
                  <div className='flex items-center gap-2'>
                    {!naoTestada && <Icon name={status.success ? 'check' : 'x'} className={`w-4 h-4 ${status.success ? 'text-green-400' : 'text-red-400'}`} />}
                    <span className='text-white font-medium'>{connectionLabels[key] || key}</span>
                  </div>
                  <p className={`text-xs mt-1 ${naoTestada ? 'text-slate-400' : status.success ? 'text-green-400' : 'text-red-400'}`}>
                    {naoTestada ? FRASE_DO_NAO_TESTADO : status.message}
                    {status.region && ` (${status.region})`}
                  </p>
                  {/* AWS Details */}
                  {key === 'aws' && status.accessKeyPreview && (
                    <p className='text-xs text-slate-500 mt-1'>Key: {status.accessKeyPreview}</p>
                  )}
                  {/* ClickSign Details */}
                  {key === 'clicksign' && (
                    <p className='text-xs text-slate-500 mt-1'>
                      {status.environment && <span>Ambiente: {status.environment}</span>}
                      {status.tokenPreview && <span> • Token: {status.tokenPreview}</span>}
                    </p>
                  )}
                  {/* Nuvem Fiscal / Focus NFe Details */}
                  {(key === 'nuvemFiscal' || key === 'focusNfe') && (
                    <div className='mt-1 space-y-1'>
                      {(status.environment || status.tokenPreview) && (
                        <p className='text-xs text-slate-500'>
                          {status.environment && <span>Ambiente: {status.environment}</span>}
                          {status.tokenPreview && <span> • Token: {status.tokenPreview}</span>}
                        </p>
                      )}
                      <p className='text-xs text-slate-500'>
                        {status.clientIdPreview && <span>Client: {status.clientIdPreview}</span>}
                      </p>
                      {status.tokenStatus && (
                        <p className='text-xs'>
                          <span className={status.tokenStatus === 'Válido' ? 'text-green-400' : 'text-red-400'}>
                            Token: {status.tokenStatus}
                          </span>
                          {status.tokenExpiresAt && (
                            <span className='text-slate-500'> (exp: {new Date(status.tokenExpiresAt).toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })})</span>
                          )}
                        </p>
                      )}
                      {status.cnpjEmissor && (
                        <p className='text-xs text-slate-500'>
                          CNPJ: {status.cnpjEmissor} • IE: {status.inscricaoEstadual}
                        </p>
                      )}
                      {status.stats && (
                        <div className='flex flex-wrap gap-1 mt-1'>
                          {status.stats.nfseAuthorized > 0 && (
                            <span className={`px-1.5 py-0.5 text-[10px] rounded ${TONE_BADGE.success}`}>
                              NFS-e: {status.stats.nfseAuthorized}
                            </span>
                          )}
                          {status.stats.nfcomAuthorized > 0 && (
                            <span className={`px-1.5 py-0.5 text-[10px] rounded ${TONE_BADGE.success}`}>
                              NFCom: {status.stats.nfcomAuthorized}
                            </span>
                          )}
                          {status.stats.processing > 0 && (
                            <span className={`px-1.5 py-0.5 text-[10px] rounded ${TONE_BADGE.progress}`}>
                              Proc: {status.stats.processing}
                            </span>
                          )}
                          {status.stats.errors > 0 && (
                            <span className='px-1.5 py-0.5 text-[10px] bg-red-500/20 text-red-400 rounded'>
                              Erros: {status.stats.errors}
                            </span>
                          )}
                          <span className='px-1.5 py-0.5 text-[10px] bg-slate-500/20 text-slate-400 rounded'>
                            Total: {status.stats.total}
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ); })}
            </div>
          </div>
        )}

        {/* Lista de Credenciais */}
        <EstadoDaLista carga={carga} temDados={carga.atualizadoEm !== null} oQue='as credenciais' onTentarDeNovo={loadData} vazio={A_PROPRIA_LISTA_DIZ_O_VAZIO}>
        {credentials.length === 0 ? (
          <div className='text-center py-8 text-slate-500'>
            <Icon name='key' className='w-12 h-12 mx-auto mb-3 opacity-50' />
            <p>Nenhuma credencial cadastrada</p>
            <p className='text-sm mt-1'>Clique em "Criar Padrões" para adicionar as credenciais comuns</p>
          </div>
        ) : (
          <div className='space-y-3'>
            {credentials.filter(c => c.type !== 'SMTP').map((cred) => {
              const days = getDaysUntil(cred.expiresAt);
              const statusStyle = statusColors[cred.status] || statusColors['Desconhecido'];

              return (
                <div key={cred.id} className='bg-slate-800 rounded-lg p-4 border border-slate-700'>
                  <div className='flex items-start justify-between'>
                    <div className='flex items-start gap-3'>
                      <div className='p-2 rounded-lg bg-slate-700/50'>
                        <Icon name={typeIcons[cred.type] || 'key'} className='w-5 h-5 text-slate-300' />
                      </div>
                      <div>
                        <div className='flex items-center gap-2'>
                          <h4 className='text-white font-medium'>{cred.name}</h4>
                          <span className={`px-2 py-0.5 text-xs font-medium rounded ${statusStyle.bg} ${statusStyle.text} border ${statusStyle.border}`}>
                            {cred.status}
                          </span>
                        </div>
                        <p className='text-slate-400 text-sm mt-0.5'>{cred.description}</p>
                        <div className='flex items-center gap-4 mt-2 text-xs text-slate-500'>
                          <span className='flex items-center gap-1'>
                            <span className='text-slate-600'>Tipo:</span> {cred.type}
                          </span>
                          {cred.expiresAt && (
                            <span className='flex items-center gap-1'>
                              <Icon name='clock' className='w-3 h-3' />
                              {days !== null && days > 0 ? (
                                <span className={days <= 14 ? TONE_TEXT.warning : ''}>
                                  Expira em {days} dias ({fmtDate(cred.expiresAt)})
                                </span>
                              ) : days === 0 ? (
                                <span className={TONE_TEXT.warning}>Expira hoje</span>
                              ) : (
                                <span className='text-red-400'>Expirado há {Math.abs(days!)} dias</span>
                              )}
                            </span>
                          )}
                        </div>
                        {cred.notes && (
                          <p className='text-xs text-slate-500 mt-2 italic'>{cred.notes}</p>
                        )}
                      </div>
                    </div>
                    <div className='flex items-center gap-1'>
                      <button
                        onClick={() => handleEdit(cred)}
                        className='p-2 text-slate-400 hover:text-white hover:bg-slate-700 rounded-lg'
                        title='Editar'
                      >
                        <Icon name='edit' className='w-4 h-4' />
                      </button>
                      <button
                        onClick={() => handleDelete(cred)}
                        className='p-2 text-slate-400 hover:text-red-400 hover:bg-slate-700 rounded-lg'
                        title='Excluir'
                      >
                        <Icon name='trash' className='w-4 h-4' />
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        </EstadoDaLista>
      </div>

      {/* Modal Create/Edit */}
      {modal && (
        // Formulário: não fecha ao clicar fora, como já era. Ganha teto de altura
        // (a caixa não tinha max-h e cortava em tela baixa).
        <CascaDeModal
          largura='sm'
          titulo={modal === 'create' ? 'Nova Credencial' : 'Editar Credencial'}
          onClose={() => setModal(null)}
          corpoClassName='p-6 space-y-4'
          rodape={
            <div className='ml-auto flex gap-3'>
              <button
                onClick={() => setModal(null)}
                className='px-4 py-2.5 text-sm font-medium text-slate-300 bg-slate-700 rounded-lg hover:bg-slate-600'
              >
                Cancelar
              </button>
              <button
                onClick={handleSave}
                disabled={saving || !form.name || !form.type}
                className='px-4 py-2.5 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-strong disabled:opacity-50'
              >
                {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          }
        >
              <div>
                <label className='block text-sm font-medium text-slate-300 mb-2'>Nome *</label>
                <input
                  type='text'
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  placeholder='Ex: AWS S3/CloudWatch'
                  className={`w-full px-4 py-2.5 ${campo} rounded-lg focus:outline-none`}
                />
              </div>

              <div>
                <label className='block text-sm font-medium text-slate-300 mb-2'>Tipo *</label>
                <select
                  value={form.type}
                  onChange={(e) => setForm({ ...form, type: e.target.value })}
                  className={`w-full px-4 py-2.5 ${campo} rounded-lg focus:outline-none`}
                >
                  <option value='AWS'>AWS</option>
                  <option value='GitHub'>GitHub</option>
                  <option value='ClickSign'>ClickSign</option>
                  <option value='NuvemFiscal'>Nuvem Fiscal</option>
                  <option value='Other'>Outro</option>
                </select>
              </div>

              <div>
                <label className='block text-sm font-medium text-slate-300 mb-2'>Descrição</label>
                <input
                  type='text'
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                  placeholder='Breve descrição da credencial'
                  className={`w-full px-4 py-2.5 ${campo} rounded-lg focus:outline-none`}
                />
              </div>

              <div className='grid grid-cols-2 gap-4'>
                <div>
                  <label className='block text-sm font-medium text-slate-300 mb-2'>Data de Expiração</label>
                  <input
                    type='date'
                    value={form.expiresAt}
                    onChange={(e) => setForm({ ...form, expiresAt: e.target.value })}
                    className={`w-full px-4 py-2.5 ${campo} rounded-lg focus:outline-none`}
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-slate-300 mb-2'>Alertar X dias antes</label>
                  <input
                    type='number'
                    value={form.alertDaysBefore}
                    onChange={(e) => setForm({ ...form, alertDaysBefore: parseInt(e.target.value) || 14 })}
                    min={1}
                    max={90}
                    className={`w-full px-4 py-2.5 ${campo} rounded-lg focus:outline-none`}
                  />
                </div>
              </div>

              <div>
                <label className='block text-sm font-medium text-slate-300 mb-2'>Notas</label>
                <textarea
                  value={form.notes}
                  onChange={(e) => setForm({ ...form, notes: e.target.value })}
                  rows={3}
                  placeholder='Informações adicionais, instruções de renovação, etc.'
                  className={`w-full px-4 py-2.5 ${campo} rounded-lg focus:outline-none`}
                />
              </div>
        </CascaDeModal>
      )}

    </div>
  );
}
